import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  unit: {
    backgroundColor: palette.shades[100],
    padding: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  smallField: {
    width: '100px',
    '& + &': {
      marginLeft: '10px'
    }
  }
});
export default useStyles;